import { Button, useDisclosure } from '@heroui/react';
import { Svg } from '@/shared/ui/Svg';
import TrashIcon from '@/shared/assets/icons/trash.svg';
import OpenedEyeIcon from '@/shared/assets/icons/opened-eye.svg';
import { DeleteMultipleModal } from '../../../../../features';
import { EntityType } from '../../../../../entities/entityConfig';
import styles from './TableHeaderActions.module.scss';

interface TableHeaderActionsProps<TData> {
  selectedRows: TData[] | undefined;
  hideSelectedRow?: (ids: number[]) => void;
  entityName?: EntityType;
}

export const TableHeaderActions = <T,>({
  selectedRows,
  hideSelectedRow,
  entityName,
}: TableHeaderActionsProps<T>) => {
  const { isOpen, onOpenChange } = useDisclosure();

  const handleHideItems = () => {
    if (!hideSelectedRow || !selectedRows) return;
    const ids = selectedRows.map((row: any) => row.id);
    hideSelectedRow(ids);
  };

  if (!selectedRows || selectedRows.length === 0) {
    return <div className={styles.toolbar} />;
  }

  return (
    <>
      <div className={styles.toolbar}>
        <p className={styles.selectedItemsCount}>Selected {selectedRows.length}</p>
        <div className="flex flex-row items-center gap-6">
          {hideSelectedRow && (
            <Button
              endContent={<Svg Icon={OpenedEyeIcon} className="text-grey-secondary" />}
              className="bg-transparent p-2 text-base text-grey-secondary font-semibold"
              onPress={handleHideItems}
            >
              Hide selected ({selectedRows.length})
            </Button>
          )}
          {entityName && (
            <Button
              className="bg-transparent p-2 text-base text-red-tertiary font-semibold"
              onPress={onOpenChange}
              endContent={<Svg Icon={TrashIcon} className="text-icon-dizlike" />}
            >
              Delete selected ({selectedRows.length})
            </Button>
          )}
        </div>
      </div>
      {entityName && (
        <DeleteMultipleModal
          selectedRows={selectedRows as any}
          isOpen={isOpen}
          onOpenChange={onOpenChange}
          entityName={entityName}
        />
      )}
    </>
  );
};
